import { observable, computed, decorate } from 'mobx';
import Widget from './dataTypes/Widget';

import { get } from '../utils/data';

class AppConfigStore {
  constructor({ config }) {
    this.basename = config.basename;
    this.experiments = config.experiments;
    this.widgets = config.widgets.map((widget) => widget.key);
    this.widgetItems = config.widgets.map(
      (widget) => new Widget(widget.key, widget.redirect),
    );
    this.staticsBaseUrl = config.staticsBaseUrl;
    this.premium = {
      exist: config.premium.exist,
    };
    this.userId = config.userId;
    this.metaSiteId = config.metaSiteId;
    this.locale = config.locale;
    this.userPermissions = config.userPermissions;

    this.get = get(config);
  }

  get getRedirectedWidgetItems() {
    return this.widgetItems.filter((widget) => widget.redirect);
  }

  get getNonRedirectedWidgetItems() {
    return this.widgetItems.filter((widget) => !widget.redirect);
  }

  get isPremium() {
    return this.premium.exist;
  }

  fetchPremium = () =>
    this.get({ path: 'is-premium' }).then(({ isPremium }) => {
      this.premium.exist = isPremium;
      return isPremium;
    });
}

export default decorate(AppConfigStore, {
  widgets: observable,
  experiments: observable,
  basename: observable,
  staticsBaseUrl: observable,
  metaSiteId: observable,
  widgetItems: observable,
  userPermissions: observable,
  getRedirectedWidgetItems: computed,
  getNonRedirectedWidgetItems: computed,
});
